import type { HelpFile } from '../../types/help'
import { InboundConnectorConfigLayoutTestIds } from '../../../testids/InboundConnectorConfigLayoutTestIds'

export const inboundConnectorConfigLayoutHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [InboundConnectorConfigLayoutTestIds.inboundConfigLayout]:
      'Sub-navigation for the Configuration tab — pick Connection, Reconciliation, or Operations.',
    [InboundConnectorConfigLayoutTestIds.inboundConfigLayoutMobile]:
      'Mobile view: configuration sub-page picker.',
    [InboundConnectorConfigLayoutTestIds.selectConfigSubpage]:
      'Switch between Connection, Reconciliation, and Operations sub-pages.',
  },
}
